import React from "react";
var __jsx = React.createElement;
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { useClickAway } from 'react-use';
import { useLinkToolbar } from 'components/common/RichTextEditor/hooks';
import { Container, Delete, Edit, Title } from './EditLinkToolbar.style';

var EditLinkToolbar = function EditLinkToolbar(_ref) {
  var onDelete = _ref.onDelete,
      updateEntity = _ref.updateEntity,
      title = _ref.title,
      _ref$linkPreview = _ref.linkPreview,
      linkPreview = _ref$linkPreview === void 0 ? __jsx(React.Fragment, null) : _ref$linkPreview,
      editComponent = _ref.editComponent,
      editorRef = _ref.editorRef,
      editorState = _ref.editorState,
      entityKey = _ref.entityKey,
      _ref$editIsDialog = _ref.editIsDialog,
      editIsDialog = _ref$editIsDialog === void 0 ? false : _ref$editIsDialog,
      _ref$firstPrintOpenMo = _ref.firstPrintOpenModal,
      firstPrintOpenModal = _ref$firstPrintOpenMo === void 0 ? false : _ref$firstPrintOpenMo;
  var intl = useIntl();

  var _useState = useState(),
      containerNode = _useState[0],
      setContainerNode = _useState[1];

  var _useState2 = useState(firstPrintOpenModal),
      isEditing = _useState2[0],
      setIsEditing = _useState2[1]; // Show editComponent on new link when is modal


  useLinkToolbar(editorRef, {
    current: containerNode
  }, editorState.getSelection().getHasFocus());
  useClickAway({
    current: containerNode
  }, function () {
    if (!editIsDialog || editIsDialog && !isEditing) {
      updateEntity(entityKey, {
        editLink: false
      }, true);
    }
  });
  var containerRef = useCallback(function (node) {
    if (node !== null) {
      setContainerNode(node);
    }
  }, []);

  if (editIsDialog) {
    return isEditing ? __jsx(React.Fragment, null, editComponent) : __jsx(Container, {
      ref: containerRef,
      "data-testid": "editLink-toolbar"
    }, __jsx(Title, null, title), linkPreview, __jsx(Delete, {
      onClick: onDelete,
      "aria-label": intl.formatMessage({
        id: 'content.labels.edit-link-toolbar.remove-link'
      })
    }), __jsx(Edit, {
      onClick: function onClick() {
        return setIsEditing(true);
      },
      "aria-label": intl.formatMessage({
        id: 'content.labels.edit-link-toolbar.edit-link'
      })
    }));
  }

  return __jsx(Container, {
    ref: containerRef,
    "data-testid": "editLink-toolbar"
  }, isEditing ? editComponent : __jsx(React.Fragment, null, __jsx(Title, null, title), linkPreview, __jsx(Delete, {
    onClick: onDelete,
    "aria-label": intl.formatMessage({
      id: 'content.edit.richtext.remove-link'
    })
  }), __jsx(Edit, {
    onClick: function onClick() {
      return setIsEditing(true);
    },
    "aria-label": intl.formatMessage({
      id: 'content.edit.richtext.edit-link'
    })
  })));
};

export default EditLinkToolbar;